import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { TArticleFeedbackCloseEventParams } from './_types';

export const articleFeedbackCloseEvent = (
  params: TArticleFeedbackCloseEventParams,
) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.ARTICLE_RATE_CANCEL_CLICK,
    params,
  });
};
